module.exports = __webpack_public_path__ + "static/media/card_diners.cae05001.svg";